<template>
  <div class="appointment-vender-receipt">
    <confirm-dialog
      v-if="sapConfirmDialog.isShow"
      :data="sapConfirmDialog"
      @confirm="handleSapConfirm"
    />
    <div class="center mb-3">
      <div>PO Number: {{ poNumber }}</div>
      <div>เลขที่ใบเสร็จ: {{ receiptNumber }}</div>
    </div>
    <div class="row">
      <div class="col-5 mb-3">
        <div class="label mb-1">วันที่ใบเสร็จ</div>
        <el-date-picker
          v-model="receiptDate"
          class="date"
          style="width: 100%"
        />
      </div>
      <div class="col-4 mb-3">
        <div class="label mb-1">เลขที่ใบเสร็จ</div>
        <el-input v-model="receiptNo" />
      </div>
      <div class="col-3 mb-3">
        <div class="label mb-1">ต้นทุนจริง</div>
        <el-input v-model="actualCost" />
      </div>
      <div class="col-12 mb-3">
        <div class="label mb-1">ผู้ให้บริการ</div>
        <provider-selector v-model="provider"></provider-selector>
      </div>
      <div class="col-12 mb-3 btn">
        <sc-button size="m" variant="danger" @click="handleCancel"
          >ยกเลิก</sc-button
        >
        <sc-button
          size="m"
          variant="warning"
          @click="handleSubmitAppointmentReceipt"
          >บันทึก</sc-button
        >
      </div>
    </div>
  </div>
</template>


<script>
import { baanRueJaiClient } from "@/dependencies";
import ScButton from "@/lib/components/ScButton";
import { convertPriceStringToInt } from "@/lib/formatter";
import { DatePicker, Input } from "element-ui";
import { DateTime } from "luxon";
import ProviderSelector from "./ProviderSelector";

export default {
  name: 'AppointmentVenderReceipt',
  components: {
    ScButton,
    "el-input": Input,
    "el-date-picker": DatePicker,
    ProviderSelector,
  },
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      appointmentId: null,
      receiptDate: null,
      receiptNo: null,
      actualCost: null,
      provider: null,
      sapConfirmDialog: {
        isShow: false,
        title: 'ยืนยันการแก้ไข',
        detail: 'หากแก้ไขข้อมูล vender จะส่ง sap mm ใหม่ในรอบถัดไป',
        buttonSubmit: 'ยืนยัน',
        buttonCancel: 'ยกเลิก',
      },
    };
  },
  computed: {
    poNumber() {
      return (this.value && this.value.poNumber) || null;
    },
    receiptNumber() {
      return (this.value && this.value.receiptNumber) || null;
    },
    isEditAfterSentToSap() {
      return (this.value && this.value.isEditAfterSentToSap) || false;
    },
  },
  watch: {
    value(newValue) {
      if (!newValue) {
        this.clearForm();
        return;
      }

      this.appointmentId = newValue.appointmentId;
      this.receiptDate = newValue.receiptAppointmentDate;
      this.receiptNo = newValue.receiptAppointmentNumber;
      this.actualCost = newValue.actualCost;
      this.provider = newValue.providerId;
    },
  },
  methods: {
    handleSubmitAppointmentReceipt() {
      if (!this.provider) {
        this.$message.error("กรุณาเลือก ผู้ให้บริการ");
        return;
      }

      if (this.isEditAfterSentToSap) {
        this.sapConfirmDialog.isShow = true;
        return;
      }

      this.submitReceipt();
    },
    handleSapConfirm(confirmed) {
      this.sapConfirmDialog.isShow = false;
      if (confirmed) {
        this.submitReceipt();
      }
    },
    async submitReceipt() {
      const providerId =
        this.provider && this.provider.id ? this.provider.id : this.provider;

      const params = {
        appointment_id: this.appointmentId,
        receipt_date: this.receiptDate
          ? DateTime.fromJSDate(new Date(this.receiptDate))
              .endOf("day")
              .toUTC()
              .toISO()
          : this.receiptDate,
        receipt_number: this.receiptNo || null,
        actual_cost: convertPriceStringToInt(this.actualCost),
        provider_id: +providerId,
        is_edit_after_sent_to_sap: this.isEditAfterSentToSap
      };

      try {
        await baanRueJaiClient.admin.subscriptions.appointments.putAppointmentReceipt(
          this.appointmentId,
          params
        );

        this.$message.success("บันทึกข้อมูลเรียบร้อย");
        window.location.reload();
      } catch (error) {
        this.$message.error("ไม่สามารถบันทึกข้อมูลได้");
      }
    },
    handleCancel() {
      this.clearForm();

      this.$emit("cancel");
    },
    clearForm() {
      this.appointmentId = null;
      this.receiptDate = null;
      this.receiptNo = null;
      this.actualCost = null;
      this.provider = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.appointment-vender-receipt {
  padding: 15px;
  border: 1px solid #b5b4b6;
  border-radius: 5px;
  margin: auto;
  background-color: #f5f5f5;

  text-align: left;
}

.center {
  text-align: center;
}

.btn {
  margin-top: 25px;
  text-align: right;
}
</style>